import styled from '@emotion/styled';
import { COLORS } from '../../../../constants/radar';

export const TabContainer = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 16px;
  margin-bottom: 0;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
`;

export const TabButton = styled.button`
  padding: 12px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: ${({ 'data-active': active }) => active ? COLORS.PRIMARY : COLORS.GRAY};
  border-bottom: 2px solid ${({ 'data-active': active }) => active ? COLORS.PRIMARY : 'transparent'};
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${COLORS.PRIMARY};
  }
`; 